import appStore from './state/store';
import { apiClient } from "./classes/ApiClient";
import { validationUtils } from "./validation/Validation";
import { eventEmitter } from "./classes/EventEmitter";
import { EVENTS } from "./AppConstants";
import * as _ from 'lodash';
import axios from "axios";

class Startup {
    configureApp() {
        //axios.interceptors.response.use(
        //    response => { console.log("axios response"); return response; },
        //    error => {
        //        console.log("AXIOS_ERROR");
        //        if (error.response && 400 === error.response.status && error.response.data && error.response.data.validationErrors) {
        //            const validationResult = validationUtils.translateServerValidationResult(error.response.data.validationErrors);
        //            //console.log(validationResult);
        //            validationUtils.publishValidationFailure(validationResult);
        //            //return Promise.reject().catch((error) => console.log(error));
        //        } else if (error.response && 400 === error.response.status && error.response.data && error.response.data.errorMessage) {
        //            eventEmitter.publish(EVENTS.API_CALL_FAILURE_BAD_REQUEST, { errorMessage: error.response.data.errorMessage });
        //        } else {
        //            console.log("API_CALL_FAILURE_COMMON");
        //            eventEmitter.publish(EVENTS.API_CALL_FAILURE_COMMON, { error: error.response });
        //        }

        //        return Promise.reject(error);
        //    }
        //);
    }
    //configureApp() {
    //    apiClient.instance.interceptors.response.use(
    //        response => response,
    //        error => {
    //            if (error.response && 400 === error.response.status && error.response.data && error.response.data.validationErrors) {
    //                const validationResult = validationUtils.translateServerValidationResult(error.response.data.validationErrors);
    //                //console.log(validationResult);
    //                validationUtils.publishValidationFailure(validationResult);
    //                //return Promise.reject().catch((error) => console.log(error));
    //            } else if (error.response && 400 === error.response.status && error.response.data && error.response.data.errorMessage) {
    //                eventEmitter.publish(EVENTS.API_CALL_FAILURE_BAD_REQUEST, { errorMessage: error.response.data.errorMessage });
    //            } else {
    //                console.log("API_CALL_FAILURE_COMMON");
    //                eventEmitter.publish(EVENTS.API_CALL_FAILURE_COMMON, { error: error.response });
    //            }

    //            return Promise.reject(error);
    //        }
    //    );
    //}
}

const startup = new Startup();
export default startup;